import { ClientComponentLogger, LogErrorParams } from '../../client-component-logger';
import { OffersTrackingComponent } from './offers-tracking.component';

/**
 *
 */
export class Logger {
    public static logError(params: LogErrorParams): void {
        const logger = new ClientComponentLogger(OffersTrackingComponent.name);
        logger.logError(params);
    }
}
